import React from "react";

const LegalPage = ({ testid, eyebrow, title, sections }) => (
  <main className="pt-[74px]" data-testid={testid}>
    <section className="section-pad">
      <div className="mx-auto max-w-[820px] px-5 sm:px-8">
        <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>{eyebrow}</p>
        <h1 className="font-display foil-text mt-3" style={{ fontSize: "var(--t-h2)", lineHeight: 1.05 }}>{title}</h1>
        <hr className="foil-rule my-8" />
        <div className="space-y-8">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-caps text-gold" style={{ fontSize: ".8rem" }}>{s.h}</h2>
              <p className="mt-3" style={{ color: "var(--parchment)" }}>{s.p}</p>
            </div>
          ))}
        </div>
        <p className="mt-12 font-caps text-ash" style={{ fontSize: ".6rem" }}>
          This is placeholder legal copy. Replace with your finalized policy before launch.
        </p>
      </div>
    </section>
  </main>
);

export default LegalPage;
